import { isFailedImportStatus } from "../lib/optroImportJobs";
import { cn } from "../lib/utils";
import { OptroImportItem } from "../models/audit/optroSync";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

interface OptroImportStatusLabelProps {
  item: OptroImportItem;
  label: string;
  className: string;
}

// An import item's status text. A failed, timed-out or cancelled item with a
// reason explains itself in a tooltip on the label; the label is focusable so
// keyboard users can open it too.
export const OptroImportStatusLabel = ({
  item,
  label,
  className,
}: OptroImportStatusLabelProps) => {
  if (!isFailedImportStatus(item.status) || !item.failureReason) {
    return <span className={className}>{label}</span>;
  }
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          tabIndex={0}
          className={cn(
            className,
            "cursor-help rounded-sm focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-stone-950",
          )}
        >
          {label}
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">{item.failureReason}</TooltipContent>
    </Tooltip>
  );
};
